export const base = {
    clickHere: '点击此处',
    viewDetail: '查看详情',
};
